//导入封装好的axios实例
import request from "./request";

// post
export const postRequest = (url, params = {}) => {
  return request({
    url,
    method: "post",
    data: params,
  });
};

// get
export const getRequest = (url, params = {}) => {
  return request({
    url,
    method: "get",
    params,
  });
};
